import React, { useEffect, useState } from "react";
import API from "../../api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Button, Card } from "react-bootstrap";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import CustomerInfo from "../smallComponent/CustomerInfo";
import { API_IMAGE_URL } from "../../lib/api";
import CustomerFilterBar from "../smallComponent/CustomerFilterBar";
import * as XLSX from "xlsx";
import { useCustomers } from "../context/CustomerContext";

export default function OldProject({ user }) {
  const [modalId, setModalId] = useState(null);
  const [modalType, setModalType] = useState("");
  const [domain, setDomain] = useState("");
  const [workProcessText, setWorkProcessText] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [viewMoreWorkDetails, setViewMoreWorkDetails] = useState([]);
  const [codeveloperTeams, setCodeveloperTeams] = useState([]);
  const [selectedCodevelopers, setSelectedCodevelopers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { allCustomers, fetchCustomers } = useCustomers();

  useEffect(() => {
    fetchCustomers();
    fetchCodeveloperTeams();
  }, []);



  // 🔹 Handle filter
  useEffect(() => {
    let result = allCustomers || [];

    // search filter
    if (search) {
      result = result.filter((c) =>
        (c.customer_name || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    // date filter
    if (startDate) {
      result = result.filter(
        (c) => new Date(c.done_date) >= new Date(startDate)
      );
    }
    if (endDate) {
      result = result.filter(
        (c) => new Date(c.done_date) <= new Date(endDate)
      );
    }

    // sirf active customers
    result = result.filter(
      (c) => c.status === 2
    );

    setFilteredCustomers(result);
    setCurrentPage(1);
  }, [allCustomers, search, startDate, endDate]);

  // 🔹 Reset
  const resetFilter = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    setFilteredCustomers(allCustomers || []);
    setCurrentPage(1);
  };


  const closeModal = () => {
    setModalId(null);
    setModalType("");
    setViewMoreWorkDetails([]);
  };

  const showMessage = (msg, isError = false) => {
    if (isError) setError(msg);
    else setMessage(msg);
    setTimeout(() => {
      setMessage("");
      setError("");
    }, 3000);
  };

  const handleAddWorkProsessing = async (e, id) => {
    e.preventDefault();

    if (!workProcessText.trim()) {
      showMessage("Please enter work process detail", true);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const fullText = `${user.full_name} - ${workProcessText.trim()}`;

      await API.post(
        `/customers/${id}/add-work-process`,
        {
          text: fullText,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setWorkProcessText("");
      closeModal();
      await fetchCustomers();
      showMessage("Work process added successfully!");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to add work process detail";
      showMessage(errorMessage, true);
    } finally {
      setLoading(false);
    }
  };

  const handleAddDomain = async (e, id) => {
    e.preventDefault();
    try {
      await API.post(`/customers/${id}/add-domain`, { domain });
      closeModal();
      setDomain("");
      fetchCustomers();
      showMessage("Domain added successfully");
    } catch {
      showMessage("Failed to add domain", true);
    }
  };

  const updateWorkParsent = async (id, percent) => {
    try {
      await API.put(`/customers/${id}/work-parsent`, {
        work_percentage: percent,
      });
      fetchCustomers();
      showMessage("Work percentage updated");
    } catch {
      showMessage("Failed to update work %", true);
    }
  };

  const handlechangeStatus = async (id, newStatus) => {
    try {
      await API.post(`/customers/${id}/accept`, { status: newStatus });
      showMessage(`Project status updated to ${newStatus}`);
      fetchCustomers();
    } catch {
      showMessage("Failed to update project status", true);
    }
  };

  const fetchCodeveloperTeams = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await API.get("/employees", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // केवल developers filter करो
      const developers = res.data.employees.filter(
        (emp) => emp.department === "Developer"
      );
      setCodeveloperTeams(developers);
      
    } catch (error) {
      console.error("Failed to fetch codeveloper teams:", error);
    }
  };

  const handleAssignCodevelopers = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await API.post(
        `/customers/${modalId}/assign-codevelopers`,
        {
          codeveloperteam_id: selectedCodevelopers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      showMessage("Codevelopers assigned successfully");
      closeModal();
      fetchCustomers();
    } catch (error) {
      showMessage("Failed to assign codevelopers", true);
    }
  };

  const openViewMoreModal = (workDetails) => {
    setViewMoreWorkDetails(workDetails || []);
    setModalType("viewAllWork");
    setModalId("viewMore");
  };


  const exportToExcel = () => {
    const data = filteredCustomers.map((c, i) => ({
      SN: i + 1,
      Name: c.customer_name,
      Phone: c.contact_number,
      Business: c.business_name,
      StartDate: c.project_start_date,
      DoneDate: c.done_date,
      Developer: c.main_developer_name,
      Salesman: c.sales_representative_name,
      Price: c.price,
      Due: c.due_amount,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
    XLSX.writeFile(workbook, "CustomerList.xlsx");
  };

  return (
    <div className="container mx-auto py-4 px-2">
      <h2 className="mb-4 text-2xl font-semibold">✅ Old Projects</h2>

      {message && (
        <div
          className="mb-4 rounded bg-green-100 border border-green-400 text-green-700 px-4 py-3"
          role="alert"
        >
          {message}
        </div>
      )}
      {error && (
        <div
          className="mb-4 rounded bg-red-100 border border-red-400 text-red-700 px-4 py-3"
          role="alert"
        >
          {error}
        </div>
      )}
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <CustomerFilterBar
            search={search}
            setSearch={setSearch}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            onExport={exportToExcel}
            onReset={resetFilter}
          />
        </Card.Body>
      </Card>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded table-fixed">
          <thead className="bg-gray-800 text-white text-sm">
            <tr>
              <th className="border border-gray-300 px-3 py-2 w-10">SN</th>
              <th className="border border-gray-300 px-3 py-2">
                Customer Info
              </th>
              <th className="border border-gray-300 px-3 py-2">Co-Developer</th>
              <th className="border border-gray-300 px-3 py-2">Work Details</th>
              <th className="border border-gray-300 px-3 py-2">
                Salesman/
                <br />
                Duration
              </th>
              <th className="border border-gray-300 px-3 py-2 w-24">Price</th>
              <th className="border border-gray-300 px-3 py-2">Work Process</th>
              <th className="border border-gray-300 px-3 py-2 w-48">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {filteredCustomers.length > 0 ? (
              filteredCustomers.map((c, i) => (
                <tr key={c.id} className="even:bg-gray-50">
                  <td className="border border-gray-300 px-3 py-2 text-center">
                    {i + 1}
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    <CustomerInfo customer={c} />
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    {/* Developer name for Co-Developer */}
                    {c.user_role === "Co-Developer" && c.developer_name && (
                      <div className="mb-1 text-sm font-semibold text-purple-700">
                        <FontAwesomeIcon icon={faCheck} /> Developer:{" "}
                        {c.developer_name}
                      </div>
                    )}

                    {/* Codeveloper team */}
                    {Array.isArray(c.codeveloper_team) && c.codeveloper_team.length > 0 ? (
                      c.codeveloper_team.map((dev) => (
                        <div key={dev.id}>
                          <FontAwesomeIcon icon={faCheck} /> {dev.full_name}
                        </div>
                      ))
                    ) : (
                      <span className="text-gray-400 text-sm">None</span>
                    )}
                  </td>

                  <td className="border border-gray-300 px-3 py-2">
                    {c.work_details}
                    <br />
                    {c.upload_quatation ? (
                      <a
                        href={`${API_IMAGE_URL}quotations/${c.upload_quatation}`}
                        className="inline-block mt-1 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        📄 Quotation
                      </a>
                    ) : (
                      <span className="text-gray-500 italic">No File</span>
                    )}
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    👤{" "}
                    {c.salesman_name || (
                      <em className="text-gray-500 italic">Not Assigned</em>
                    )}
                    <br />
                    ⏱️{" "}
                    {c.project_duration || (
                      <em className="text-gray-500 italic">N/A</em>
                    )}{" "}
                    Days
                  </td>
                  <td className="border border-gray-300 px-3 py-2 text-center">
                    <strong className="text-green-600">₹{c.price}</strong>
                    <br />
                    <small className="text-red-600">Due: ₹{c.due_amount}</small>
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    <div className="mb-2">
                      {c.work_process_details.length > 0 ? (
                        <ul className="list-disc pl-5 mb-2 max-h-24 overflow-y-auto">
                          {c.work_process_details.slice(-2).map((w, wi) => (
                            <li key={wi}>
                              <strong>{w.date || "N/A"}:</strong> {w.text || w}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <small className="text-gray-500 italic">
                          No details yet
                        </small>
                      )}
                      <div className="flex gap-2 mt-2">
                        <button
                          onClick={() => {
                            setModalId(c.id);
                            setModalType("work");
                            setWorkProcessText("");
                          }}
                          className="px-3 py-1 bg-yellow-400 hover:bg-yellow-500 text-black rounded text-sm"
                        >
                          ➕ Add
                        </button>

                        {c.work_process_details.length > 2 && (
                          <button
                            onClick={() =>
                              openViewMoreModal(c.work_process_details)
                            }
                            className="px-3 py-1 border border-blue-600 text-blue-600 rounded text-sm hover:bg-blue-100"
                          >
                            View More
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="flex items-center gap-1 mt-2 max-w-xs">
                      <input
                        type="number"
                        min={0}
                        max={100}
                        defaultValue={c.work_percentage}
                        onBlur={(e) => updateWorkParsent(c.id, e.target.value)}
                        className="flex-grow px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Work %"
                      />
                      <button
                        onClick={() =>
                          updateWorkParsent(c.id, c.work_percentage)
                        }
                        className="px-3 py-1 bg-green-600 hover:bg-green-700 text-white rounded"
                        aria-label="Confirm work percent"
                        title="Confirm work %"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </div>
                  </td>
                  <td className="border border-gray-300 px-3 py-2 text-center space-y-1">
                    <button
                      onClick={() => handlechangeStatus(c.id, 3)}
                      disabled={c.work_percentage !== 100}
                      className={`px-3 me-1 py-1 rounded text-sm ${
                        c.work_percentage !== 100
                          ? "bg-gray-400 cursor-not-allowed text-white"
                          : "bg-blue-600 hover:bg-blue-700 text-white"
                      }`}
                    >
                      Done
                    </button>
                    <button
                      onClick={() => {
                        setModalId(c.id);
                        setModalType("domain");
                        setDomain("");
                      }}
                      className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm"
                    >
                      ➕ Domain
                    </button>
                    {c.user_role === "Main Developer" && (
                      <button
                        onClick={() => {
                          setModalId(c.id);
                          setModalType("codeveloper");
                        }}
                        className="px-3 py-1 bg-purple-600 hover:bg-purple-700 text-white rounded text-sm"
                      >
                        ➕ Codeveloper
                      </button>
                    )}
                    <div className="mt-1 flex justify-center gap-1">
                      <a
                        href={`tel:${c.contact_number}`}
                        className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-sm inline-flex items-center justify-center"
                        aria-label="Call customer"
                      >
                        <FontAwesomeIcon icon={faPhone} />
                      </a>
                      <a
                        href={`https://wa.me/${c.contact_number}`}
                        target="_blank"
                        rel="noreferrer"
                        className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-sm inline-flex items-center justify-center"
                        aria-label="WhatsApp customer"
                      >
                        <FontAwesomeIcon icon={faWhatsapp} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">
                  No customers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal Backdrop & Container */}
      {modalId !== null && (modalType === "work" || modalType === "domain") && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900 text-2xl font-bold"
              aria-label="Close modal"
            >
              &times;
            </button>

            {modalType === "work" && (
              <form onSubmit={(e) => handleAddWorkProsessing(e, modalId)}>
                <h3 className="text-xl font-semibold mb-4">Add Work Process</h3>
                <label
                  className="block mb-2 font-medium"
                  htmlFor="workProcessInput"
                >
                  Work Detail
                </label>
                <input
                  id="workProcessInput"
                  type="text"
                  value={workProcessText}
                  onChange={(e) => setWorkProcessText(e.target.value)}
                  placeholder="Describe the step completed"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded disabled:opacity-50"
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            )}

            {modalType === "domain" && (
              <form onSubmit={(e) => handleAddDomain(e, modalId)}>
                <h3 className="text-xl font-semibold mb-4">Add Domain</h3>
                <label className="block mb-2 font-medium" htmlFor="domainInput">
                  Domain Name
                </label>
                <input
                  id="domainInput"
                  type="text"
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  placeholder="e.g. example.com"
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                  >
                    Save
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* View All Work Modal */}
      {modalType === "viewAllWork" && modalId === "viewMore" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full p-6 relative max-h-[80vh] overflow-y-auto">
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900 text-2xl font-bold"
              aria-label="Close modal"
            >
              &times;
            </button>
            <h3 className="text-xl font-semibold mb-4">
              All Work Process Details
            </h3>
            {viewMoreWorkDetails.length > 0 ? (
              <ul className="list-disc pl-6 space-y-1">
                {viewMoreWorkDetails.map((w, i) => (
                  <li key={i}>
                    <strong>{w.date || "N/A"}:</strong> {w.text || w}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500 italic">
                No work process details available.
              </p>
            )}
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {modalId !== null && modalType === "codeveloper" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900 text-2xl font-bold"
            >
              &times;
            </button>
            <h3 className="text-xl font-semibold mb-4">
              Assign Codeveloper Teams
            </h3>
            <form onSubmit={handleAssignCodevelopers}>
              <label className="block mb-2 font-medium">
                Select Codevelopers
              </label>

              <select
                value=""
                onChange={(e) => {
                  const selectedId = e.target.value;
                  if (
                    selectedId &&
                    !selectedCodevelopers.includes(selectedId)
                  ) {
                    setSelectedCodevelopers((prev) => [...prev, selectedId]);
                  }
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded mb-2"
              >
                <option value="" disabled>
                  Select Codeveloper
                </option>
                {codeveloperTeams
                  .filter(
                    (team) => !selectedCodevelopers.includes(String(team.id))
                  )
                  .map((team) => (
                    <option key={team.id} value={team.id}>
                      {team.full_name}
                    </option>
                  ))}
              </select>

              {/* Selected Codeveloper Tags */}
              <div className="flex flex-wrap gap-2 mb-4">
                {selectedCodevelopers.map((id) => {
                  const team = codeveloperTeams.find(
                    (t) => String(t.id) === String(id)
                  );
                  return (
                    <div
                      key={id}
                      className="flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
                    >
                      {team?.full_name}
                      <button
                        type="button"
                        className="ml-2 text-blue-500 hover:text-red-500 font-bold"
                        onClick={() =>
                          setSelectedCodevelopers((prev) =>
                            prev.filter((cid) => cid !== id)
                          )
                        }
                      >
                        &times;
                      </button>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Assign
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
